<template>
  <div @click="handleGoTo('desktop-ini')" style="position:relative;">
    <video 
      v-if="!endVideo && config.DesignByCardsDesktopHeaderVideo"
      id="header-video"
      width="100%" height="auto" autoplay muted playsinline
      style="top:0;"
    >
      Your browser does not support the video tag.
      <source :src="config.DesignByCardsDesktopHeaderVideo" type="video/mp4">
    </video>
    <v-img
      v-if="endVideo && config.DesignByCardsDesktopHeaderImage"
      width="100%"
      height="auto"
      :src="config.DesignByCardsDesktopHeaderImage"
      style="top:0;"
    />
    <div class="logo" :style="{ backgroundImage: `url('${config.DesignByCardsLogo}')` }" />
    <div class="center" >
      <div class="d-flex justify-content-center"
        style="
        position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
        "
      >
					<div class="mouse-scroll">
						<div class="mouse">
							<div class="wheel"></div>
						</div>
						<div class="arrow"></div>
					</div>
				</div>
    </div>
    <div id="desktop-ini" />
  </div>
  <!--v-expansion-panel-header
    v-show="!isHideHeader"
    v-slot="{  }"
    expand-icon=""
    style="padding: 0 0 10px 0;height:150px;"
    :style="{
      'border-radius': `${borderRadius} ${borderRadius} 0 0`,
      'background-color': BGColor, 'color': Color
    }"
    @click="handleClickMainMenu"
  >
    <allergens-filter v-if="!isSimulation && allergenFilters" />
    <v-layout
      v-if="isMenu"
      wrap
      align-center
      justify-center
    >
      <v-flex xs12
        :style="{ 'margin-left': allergenFilters ? '20px' : '0'}"
      >
        <img
          :src="Logo"
          style="height:150px;"
          alt="logo"
        >
      </v-flex>
      <v-flex xs12>
        <div class="text-center"
          :style="{ 'margin-right': allergenFilters ? '-20px' : '0'}"
        >
        <custom-auth 
          :type="authType"
        />
        </div>
      </v-flex>
      <v-flex x8 v-if="isMnuLeft">
        <div
          style="margin-left: 40px">
          <v-icon
            style="margin-bottom: 5px"
            :style="{ 'color': Color }"
          >
            mdi-menu
          </v-icon>
        </div>
      </v-flex>
      <v-flex
        v-if="!isMnuLeft"
        xs4
      />
      <v-flex xs4
        v-if="!isMnuLeft"
      >
        <div class="text-center"
          :style="{ 'margin-right': allergenFilters ? '-20px' : '0',
             }"
        >
          <v-icon
            style="margin-bottom: 5px"
            :style="{ 'color': Color }"
          >
            mdi-menu
          </v-icon>
        </div>
      </v-flex>
      <v-flex xs4>
        <div class="text-right" v-if="isAdmin || !isCommonMenus">
          <v-btn v-if="onAdd" fab dark small color="#00000033" style="margin-right: 5px" @click.stop="onAdd">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout
      v-else
      wrap
      align-center
      justify-center
    >
      <v-flex xs12
          :style="{ 'margin-right': allergenFilters ? '-20px' : '0'}"
      >
        <img
          :src="Logo"
          style="height:150px;"
          alt="logo"
        >
      </v-flex>
      <v-flex xs12>
        <div class="text-center"
          :style="{ 'margin-right': allergenFilters ? '-20px' : '0'}"
        >
        <custom-auth 
          v-if="!isTotem"
          :type="authType"
        />
        </div>
      </v-flex>
      <v-flex xs12 v-if="!isDesignByCards">
        <div 
          v-bind:class="isMnuLeft ? '' : 'text-center'"
          :style="{ 'margin-right': !isMnuLeft && allergenFilters ? '-20px' : '0',
                    'margin-left': isMnuLeft ? '40px' : null,
                  }"
        >
          <v-tooltip v-model="showHelpMenu" top>
            <template v-slot:activator="{  }">
              <v-icon
                style="margin-bottom: 5px"
                :style="{ 'color': Color }"
              >
                mdi-menu
              </v-icon>
            </template>
            <span>Pulse <v-icon style="color: red">mdi-menu</v-icon> para mostrar las opciones</span>
          </v-tooltip>
        </div>
      </v-flex>
    </v-layout>
  </v-expansion-panel-header-->
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import AllergensFilter from '../../mobile/customMenu/items/foodDrink/AllergensFilter'
  import CustomAuth from '@/components/customAuth/Index'
  import constants from '@/constants'
  import _ from 'lodash'
  export default {
    components: {
      AllergensFilter,
      CustomAuth,
    },
    props: {
      ID: {
        type: String,
        required: false,
        default: null
      },
      domain: {
        type: String,
        required: false,
        default: null
      },
      onAdd: {
        type: Function,
        required: false,
        default: null
      },
      onClickMainMenu: {
        type: Function,
        required: false,
        default: null
      },
      isDesignByCards: {
        type: Boolean,
        default: false,
      },
      isTotem: {
        type: Boolean,
        defautl: false,
      },
      config: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      headerVideo: null,
      endVideo: false,
      showHelpMenu: false,
      isMnuLeft: false,
    }),
    computed: {
      ...mapState('app',['authType', 'isAdmin', 'withLine', 'BGColor', 'Logo', 'Color', 'isMenuLeft']),
      notIni () {
        return this.$route.query.b ? true : false
      },
      isHideHeader () {
        return this.$route.query.hideHeader === 'true' ? true : false
      },
      allergenFilters () {
        return this.$store.state.app.allergenFilters ? true : false
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      borderRadius () {
        return this.isSimulation ? constants.borderRadius : null
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isCommonMenus () {
        // para saber si son menús comunes entre empresas
        return this.$route.path.indexOf('/common-menus') >= 0 ? true : false
      },
    },
    watch: {
      'isMenuLeft' (v) {
        alert(v)
        this.isMnuLeft = this.$store.state.app.isMenuLeft
      },
    },
    mounted () {
      this.isMnuLeft = this.$store.state.app.isMenuLeft
      if(!this.isSimulation) this.handleSetStats()
      // this.handleShowHelpMenu()
      this.headerVideo = document.getElementById('header-video')
      if (this.headerVideo && !this.notIni) this.headerVideo.addEventListener('ended', this.handleEndVideo, false)
      else this.handleEndVideo()
    },
    methods: {
      handleGoTo (v) {
        if (!this.endVideo) this.endVideo = true
        setTimeout(() => {
          document.getElementById(v).scrollIntoView()
        }, 1000)
      },
      handleEndVideo () {
        this.endVideo = true
        if (this.notIni) { 
          //console.log(document.body.scrollTop)
          this.handleGoTo('desktop-ini')
          const query = Object.assign({}, this.$router.currentRoute.query)
          if (query && query.b) delete query.b
          this.$router.replace({ query })
        }
      },
      handleSetStats () {
        // añadimos los registros de accesos públicos
        api.setStats('stats', null)
      },
      handleShowHelpMenu: _.debounce(function (e) {
        if (!this.isSimulation) this.showHelpMenu = true
      }, 2000),
      handleClickMainMenu () {
        if (this.onClickMainMenu) this.onClickMainMenu()
      },
    },
  }
</script>
<style scoped>
  .v-content {
    /* background-color: blue; */
  }
.logo {
  position: absolute;
  top:0;
  left:0;
  width: 200px;
  height: 200px;
  background-repeat: no-repeat;
  background-size: contain;
  padding:5px;
  padding: 10px;
}
.center {
  position: absolute;
  left:  20%;
  right: 20%;
  bottom:20%;
  top: 20%;
  margin:10px;
  padding:10px;
  color: white;
  /*
  background-image: url("https://www.dtouch.es/assets/mouse-scroll.jpg");
  */
  background-repeat: no-repeat;
  background-size: contain;
  padding: 10px;
}
.mouse-scroll {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
}

.mouse {
	width: 48px;
	height: 80px;
	border: 4px solid #FFF;
	border-radius: 24px;
	display: flex;
	justify-content: center;
	align-items: start;
}

.wheel {
	width: 8px;
	height: 16px;
	background-color: #FFF;
	border-radius: 4px;
	animation: scroll 1s infinite;
	margin-top: 8px;
}

/* Scroll animation */
@keyframes scroll {
	0% {
		transform: translateY(0);
	}

	50% {
		transform: translateY(8px);
	}

	100% {
		transform: translateY(0);
	}
}

.arrow {
	width: 10px;
	height: 10px;
	border-right: 2px solid #FFF;
	border-bottom: 2px solid #FFF;
	transform: rotate(45deg);
}
</style>
